import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_TITLE_AR = "RARE GROUP | ورد وهدايا فاخرة في قطر";
const SITE_TITLE_EN = "RARE GROUP | Premium Flowers & Gifts in Qatar";
const DEFAULT_DESC_AR = "RARE GROUP — متجر ورد وهدايا فاخرة في قطر. باقات ورد طبيعية، شوكولاتة وهدايا مناسبات مع توصيل خلال ساعة في الدوحة 🌸";
const DEFAULT_DESC_EN = "RARE GROUP — premium flowers & gifts store in Qatar. Fresh bouquets, chocolates and occasion gifts with 1-hour delivery in Doha 🌸";

export default function Seo({ title, description, image, url, type = "website", jsonLd }) {
  const isAr = (typeof document !== "undefined" ? document.documentElement.lang : "ar") !== "en";
  const fullTitle = title ? `${title} | RARE GROUP` : (isAr ? SITE_TITLE_AR : SITE_TITLE_EN);
  const desc = (description || (isAr ? DEFAULT_DESC_AR : DEFAULT_DESC_EN)).slice(0, 300);
  const href = url || (typeof window !== "undefined" ? window.location.href : "https://rgpro.info/");
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={href} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={href} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
